import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Loader2, Truck, ArrowRight } from "lucide-react";
import { formatCurrency } from "../../lib/utils";

export default function ConvertToOrderDialog({
  open,
  onClose,
  selectedList,
  suppliers,
  selectedSupplier,
  setSelectedSupplier,
  onConvert,
  converting
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Convertir a pedido</DialogTitle>
          <DialogDescription>
            Selecciona el proveedor al que enviar este pedido
          </DialogDescription>
        </DialogHeader>
        
        {suppliers.length === 0 ? (
          <div className="py-8 text-center">
            <Truck className="w-12 h-12 mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground mb-4">No tienes proveedores registrados</p>
            <Button variant="outline" asChild>
              <a href="/app/suppliers">Añadir proveedor</a>
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">Proveedor</label>
              <Select value={selectedSupplier} onValueChange={setSelectedSupplier}>
                <SelectTrigger>
                  <SelectValue placeholder="Seleccionar proveedor..." />
                </SelectTrigger>
                <SelectContent>
                  {suppliers.map((supplier) => (
                    <SelectItem key={supplier.supplier_id} value={supplier.supplier_id}>
                      {supplier.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {selectedList && (
              <div className="p-4 bg-muted/50 rounded-lg">
                <p className="font-medium">{selectedList.name}</p>
                <p className="text-sm text-muted-foreground">
                  {selectedList.items.length} productos · {formatCurrency(selectedList.total_estimated_cost)}
                </p>
              </div>
            )}

            <div className="flex gap-3 justify-end">
              <Button variant="outline" onClick={onClose}>
                Cancelar
              </Button>
              <Button onClick={onConvert} disabled={converting || !selectedSupplier}>
                {converting ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Convirtiendo...
                  </>
                ) : (
                  <>
                    Crear pedido
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </>
                )}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
